<template lang="pug">
.savedpeople
  .backdrop
  .content
    .close(@click="close") ×
    NewTranslation(path="savedPeopleDialog.title").title
    .list
      .list-entry(v-for="person in savedPeople" @click="selectPerson(person)")
        .list-entry-icon
          font-awesome-icon(icon="user")
        .list-entry-text {{person.firstName + ' ' + person.lastName}}
        font-awesome-icon(icon="chevron-down" class="arrow-icon")
    Button(color="gray" @click.native="close" center path="savedPeopleDialog.close.button").button
</template>

<script>
import { mapGetters } from 'vuex';
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';

export default {
  components: {
    NewTranslation,
    Button,
  },
  props: ['overlaydata'],
  methods: {
    close() {
      this.$store.commit('openOverlay', '');
    },
    selectPerson(person) {
      this.overlaydata.callback(person);
      this.close();
    },
  },
  computed: {
    ...mapGetters(['savedPeople']),
  },
};
</script>

<style lang="sass" scoped>
.savedpeople
  width: 100%
  height: 100vh
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: fixed
  max-width: 480px
  margin: 0 auto
  right: 0
  top: 0
  left: 0
  z-index: 9
.backdrop
  background-color: rgba(0, 0, 0, .8)
  width: 100%
  height: 100vh
  position: absolute
  z-index: 6
.close
  position: absolute
  right: 20px
  top: 20px
  background-color: #fff
  z-index: 9
  color: #1DB2D1
  border: 1px solid #1DB2D1
  width: 20px
  height: 20px
  display: flex
  justify-content: center
  align-items: center
  border-radius: 20px
.content
  z-index: 7
  background-color: #fff
  border-radius: 10px
  padding: 20px
  margin: 20px
  position: relative
  width: calc(100% - 40px)
  max-height: calc(100% - 100px)
  overflow: auto
.title
  font-size: 20px
  color: #1DB2D1
  text-align: center
.list
  margin: 30px 0
  &-entry
    display: flex
    align-items: center
    padding: 20px 0
    & + &
      border-top: 1px solid #F4F4F6
    &-icon
      width: 32px
      height: 32px
      display: flex
      align-items: center
      justify-content: center
      border-radius: 50px
      color: #454F63
      border: 1px solid #454F63
      margin-right: 10px
      svg
        width: 14px
    .arrow-icon
      display: block
      font-size: 10px
      margin-left: auto
      margin-right: 5px
      color: #1DB2D1
</style>
